import { z } from "zod"

export enum LegalDocumentType {
  TERMS_OF_SERVICE = "TERMS_OF_SERVICE",
  PRIVACY_POLICY = "PRIVACY_POLICY",
}

export const LegalDocumentSchema = z.object({
  id: z.string().uuid(),
  link: z.string().url(),
  type: z.nativeEnum(LegalDocumentType),
  storeId: z.string().uuid(),
})

export const CreateLegalDocumentSchema = LegalDocumentSchema.omit({
  id: true,
})

export type LegalDocument = z.infer<typeof LegalDocumentSchema>
export type CreateLegalDocument = z.infer<typeof CreateLegalDocumentSchema>
